/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CollectionModelProductMappingResponse } from '../models/collection-model-product-mapping-response';
import { createProductMapping } from '../fn/product-mapping/create-product-mapping';
import { CreateProductMapping$Params } from '../fn/product-mapping/create-product-mapping';
import { deleteProductMapping } from '../fn/product-mapping/delete-product-mapping';
import { DeleteProductMapping$Params } from '../fn/product-mapping/delete-product-mapping';
import { getProductMapping } from '../fn/product-mapping/get-product-mapping';
import { GetProductMapping$Params } from '../fn/product-mapping/get-product-mapping';
import { getProductMappings } from '../fn/product-mapping/get-product-mappings';
import { GetProductMappings$Params } from '../fn/product-mapping/get-product-mappings';
import { getProductMappings1 } from '../fn/product-mapping/get-product-mappings-1';
import { GetProductMappings1$Params } from '../fn/product-mapping/get-product-mappings-1';
import { PagedModelProductMappingResponse } from '../models/paged-model-product-mapping-response';
import { patchProductMapping } from '../fn/product-mapping/patch-product-mapping';
import { PatchProductMapping$Params } from '../fn/product-mapping/patch-product-mapping';
import { ProductMappingResponse } from '../models/product-mapping-response';
import { updateProductMapping } from '../fn/product-mapping/update-product-mapping';
import { UpdateProductMapping$Params } from '../fn/product-mapping/update-product-mapping';


/**
 * Product mapping management. A product mapping links a seller SKU to a marketplace productId, enabling price and stock synchronization. Required role: EASYLOT_ADMIN or PRICE_SYNC_ADMIN.
 */
@Injectable({ providedIn: 'root' })
export class ProductMappingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getProductMapping()` */
  static readonly GetProductMappingPath = '/product-mapping/{productMappingId}';

  /**
   * Get product mapping by ID.
   *
   * Returns a single product mapping by its UUID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductMapping()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductMapping$Response(params: GetProductMapping$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductMappingResponse>> {
    const obs = getProductMapping(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get product mapping by ID.
   *
   * Returns a single product mapping by its UUID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductMapping$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductMapping(params: GetProductMapping$Params, context?: HttpContext): Observable<ProductMappingResponse> {
    const resp = this.getProductMapping$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProductMappingResponse>): ProductMappingResponse => r.body)
    );
  }

  /** Path part for operation `updateProductMapping()` */
  static readonly UpdateProductMappingPath = '/product-mapping/{productMappingId}';

  /**
   * Replace product mapping.
   *
   * Fully replaces the data of an existing product mapping. All fields must be provided.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProductMapping()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProductMapping$Response(params: UpdateProductMapping$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductMappingResponse>> {
    const obs = updateProductMapping(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Replace product mapping.
   *
   * Fully replaces the data of an existing product mapping. All fields must be provided.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateProductMapping$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProductMapping(params: UpdateProductMapping$Params, context?: HttpContext): Observable<ProductMappingResponse> {
    const resp = this.updateProductMapping$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProductMappingResponse>): ProductMappingResponse => r.body)
    );
  }

  /** Path part for operation `deleteProductMapping()` */
  static readonly DeleteProductMappingPath = '/product-mapping/{productMappingId}';

  /**
   * Delete product mapping.
   *
   * Permanently deletes a product mapping by its UUID. After deletion, price and stock sync for the associated SKU will fail until a new mapping is created.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteProductMapping()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProductMapping$Response(params: DeleteProductMapping$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteProductMapping(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete product mapping.
   *
   * Permanently deletes a product mapping by its UUID. After deletion, price and stock sync for the associated SKU will fail until a new mapping is created.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteProductMapping$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProductMapping(params: DeleteProductMapping$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteProductMapping$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchProductMapping()` */
  static readonly PatchProductMappingPath = '/product-mapping/{productMappingId}';

  /**
   * Partially update product mapping.
   *
   * Applies a partial update to an existing product mapping. Only provided fields are updated.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchProductMapping()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchProductMapping$Response(params: PatchProductMapping$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductMappingResponse>> {
    const obs = patchProductMapping(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Partially update product mapping.
   *
   * Applies a partial update to an existing product mapping. Only provided fields are updated.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchProductMapping$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchProductMapping(params: PatchProductMapping$Params, context?: HttpContext): Observable<ProductMappingResponse> {
    const resp = this.patchProductMapping$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProductMappingResponse>): ProductMappingResponse => r.body)
    );
  }

  /** Path part for operation `getProductMappings()` */
  static readonly GetProductMappingsPath = '/product-mappings';

  /**
   * List product mappings (paginated).
   *
   * Returns a paginated list of product mappings. Optionally filter by merchant ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductMappings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductMappings$Response(params: GetProductMappings$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelProductMappingResponse>> {
    const obs = getProductMappings(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List product mappings (paginated).
   *
   * Returns a paginated list of product mappings. Optionally filter by merchant ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductMappings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductMappings(params: GetProductMappings$Params, context?: HttpContext): Observable<PagedModelProductMappingResponse> {
    const resp = this.getProductMappings$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelProductMappingResponse>): PagedModelProductMappingResponse => r.body)
    );
  }

  /** Path part for operation `createProductMapping()` */
  static readonly CreateProductMappingPath = '/product-mappings';

  /**
   * Create product mappings.
   *
   * Creates one or more new product mappings (SKU → productId). Once created, price and stock sync for the mapped SKUs becomes possible.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createProductMapping()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createProductMapping$Response(params: CreateProductMapping$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectionModelProductMappingResponse>> {
    const obs = createProductMapping(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create product mappings.
   *
   * Creates one or more new product mappings (SKU → productId). Once created, price and stock sync for the mapped SKUs becomes possible.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createProductMapping$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createProductMapping(params: CreateProductMapping$Params, context?: HttpContext): Observable<CollectionModelProductMappingResponse> {
    const resp = this.createProductMapping$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CollectionModelProductMappingResponse>): CollectionModelProductMappingResponse => r.body)
    );
  }

  /** Path part for operation `getProductMappings1()` */
  static readonly GetProductMappings1Path = '/product-mappings/all';

  /**
   * Get all product mappings (unpaginated).
   *
   * Returns all product mappings as a collection. Optionally filter by merchant ID. Use `/product-mappings` for the paginated variant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductMappings1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductMappings1$Response(params?: GetProductMappings1$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectionModelProductMappingResponse>> {
    const obs = getProductMappings1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all product mappings (unpaginated).
   *
   * Returns all product mappings as a collection. Optionally filter by merchant ID. Use `/product-mappings` for the paginated variant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductMappings1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductMappings1(params?: GetProductMappings1$Params, context?: HttpContext): Observable<CollectionModelProductMappingResponse> {
    const resp = this.getProductMappings1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CollectionModelProductMappingResponse>): CollectionModelProductMappingResponse => r.body)
    );
  }

}
